export default function notifyCall2ActionReached() {
    if (window.top && window.top.postMessage) {
        window.top.postMessage('kwizzad.call2Action', '*');
    }
}



// WEBPACK FOOTER //
// ./src/lib/notify-call2action-reached.jsx